<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="650"
    [nzVisible]="isVisibleRoleDrawer" [nzTitle]="roleDrawerTitle" [nzFooter]="footerTpl" (nzOnClose)="handleCancel()">
    <form nz-form *nzDrawerContent [formGroup]="_fS.rolesForm">
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="roleNameError">
                        <label class="label-text required">Role name</label>
                        <input type="text" pattern="^(?!\s+$).+" class="input-group" nz-input formControlName="roleName"
                            [nzDisabled]="isRoleNameLocked"
                            maxlength="50" minlength="2">
                        <p *ngIf="_uiSystemRoleLabel" class="vis-grey fs-12">
                            Application role: <b>{{_uiSystemRoleLabel}}</b>.
                            {{isRoleNameLocked ? 'This name cannot be changed.' : ''}}
                        </p>
                        <ng-template #roleNameError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter Role Name</ng-container>
                            <ng-container *ngIf="control.hasError('minlength')">Role name {{validationMessage.minlength}}</ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Please enter Role Name</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="descriptionError">
                        <label class="label-text required">Description</label>
                        <textarea type="text"
                            pattern="^[A-Z-a-z0-9,./#@'?^*%$&!;:-_()+=&quot;{}|\n\s][A-Z-a-z0-9 ,./#@'?^*%$&!;:-_()+=&quot;{}|\s\r\n]{1,150}$"
                            class="input-group" nz-input formControlName="description" maxlength="150"
                            minlength="2"></textarea>
                        <ng-template #descriptionError let-control>
                            <ng-container *ngIf="control.hasError('required')">Please enter Description</ng-container>
                            <ng-container *ngIf="control.hasError('pattern')">Role description {{validationMessage.minlength}}</ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="8" *ngIf="currentSelectedTab == 0">
            <div nz-col nzSpan="24">
                <nz-form-item class="switch-box mt-2">
                    <nz-form-control>
                        <label nz-checkbox formControlName="isBrooklynActive" [nzDisabled]="selectedRoleData != null">Brooklyn Access</label>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div nz-row [nzGutter]="8">
            <div nz-col nzSpan="24">
                <nz-form-item class="margin-none">
                    <nz-form-control class="switch-box">
                        <label nz-checkbox formControlName="isActiveRole">Active</label>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
    <ng-template #footerTpl>
        <div class="d-flex">
            <button nz-button nzType="primary" (click)="handleOk()" class="medium-btn small-btn width-100 mr-1"
                [nzLoading]="isLoadingOne">{{selectedRoleData != null ? 'Update' : 'Add'}}</button>
            <button nz-button nzType="default" (click)="handleCancel()"
                class="dlt-btn width-100">Cancel</button>
        </div>
    </ng-template>
</nz-drawer>